import React from 'react'

const CutomerPage = () => {
  return (
    <div className='mx-3'>CutomerPage</div>
  )
}

export default CutomerPage